var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.295,
    height: 18.003,
    viewBox: "0 0 20.295 18.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8083",
    "data-name": "Path 8083",
    d: "M13.26,3A9.009,9.009,0,0,0,4,12H2.21a.5.5,0,0,0-.35.85l2.79,2.8a.5.5,0,0,0,.71,0l2.79-2.8A.5.5,0,0,0,7.79,12H6a7,7,0,0,1,7.1-7A7.089,7.089,0,0,1,20,11.9,7,7,0,0,1,13,19a6.9,6.9,0,0,1-4.28-1.48,1,1,0,0,0-1.24,1.57A8.858,8.858,0,0,0,13,21a9.009,9.009,0,0,0,9-9.26A9.106,9.106,0,0,0,13.26,3Zm-.51,5a.755.755,0,0,0-.75.75v3.68a1.012,1.012,0,0,0,.49.86l3.12,1.85a.751.751,0,1,0,.77-1.29L13.5,12.14V8.74A.753.753,0,0,0,12.75,8Z",
    transform: "translate(-1.708 -2.997)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLog);
export default __webpack_public_path__ + "static/media/timeLog.f04f5134378eb9b4ef63b07d0c4cb981.svg";
export { ForwardRef as ReactComponent };